export { extractSubdomain } from './extractSubdomain';
export { verifySubdomain } from './verifySubdomain';
